import ImgSwitcher from '@/js/components/imgSwitcher'

const main = () => {
    if(!document.querySelector('#page-download')) return false;
    const imgSwitcher = new ImgSwitcher(
        $('#sample'),
        {
            mainClass: 'items > ul',
            mainInnerClass : 'items > ul',
            changeMode : 'slide',
            autoChange : false,
            imgResize : true,
            touch : true,
            changeSpeed : 600,
            defaultSlideNum: 1,
        }
    );
}
export default main;
